module.exports = __webpack_public_path__ + "img/hashtag.ff671cd1.svg";